export const GETHECKED = 'GETHECKED' // 获取是否开启日期管理、货位管理
export const PRODUCTIONOPEN = 'PRODUCTIONOPEN' // 开启或关闭日期管理、货位管理
export const CONFIGBILLCHECKDAYS = 'CONFIGBILLCHECKDAYS' // 账单核对策略
export const GETBILLCHECKDAYS = 'GETBILLCHECKDAYS' // 获取仓库账单核对时间
export const SELECTAREALIST = 'SELECTAREALIST'
export const GETPUTCONFIG = 'GETPUTCONFIG'
export const SETPUTCONFIG = 'SETPUTCONFIG'
export const GETOUTCONFIG = 'GETOUTCONFIG'
export const SETOUTCONFIG = 'SETOUTCONFIG'



// WEBPACK FOOTER //
// ./src/store/warehouseTactics/types.js